import React from 'react';
import { useParams } from 'react-router-dom';
import { paths } from '@/app/paths';
import { useGetRelationshipCompanyQuery } from '@/features/relationshipCompanies/relationshipCompaniesApi';
import RecordRouteGuard from '.';

export const RelationshipCompanyRouteGuard = ({ children }) => {
	const { relationshipCompanyId } = useParams();
	const { currentData, isLoading, isFetching, isUninitialized, error } =
		useGetRelationshipCompanyQuery(relationshipCompanyId);

	return (
		<RecordRouteGuard
			id={relationshipCompanyId}
			record={currentData}
			isLoading={isLoading || isFetching || isUninitialized}
			error={error}
			label='company'
			listPath={paths.relationships}
		>
			{children}
		</RecordRouteGuard>
	);
};
